export enum BulkImportStatus {
  Created = 'CREATED',
  Processing = 'PROCESSING',
  Succeeded = 'SUCCEEDED',
  Partial = 'PARTIAL',
  Failed = 'FAILED',
  Cancelled = 'CANCELLED'
}
export enum BulkImportType {
  Offers = 'OFFERS',
  CLEAR_OFFER = 'CLEAR_OFFER',
  Baselines = 'BASELINES'
}

export interface BulkImportRequest {
  import_name: string;
  registration_id: string;
  import_type: BulkImportType;
}

export interface BulkImportInitResponse {
  user_id: string;
  import_id: string;
  url: string;
  registration_id: string;
  import_type: BulkImportType;
  trace_id: string;
}

export interface BulkImportStatusData {
  import_id: string;
  registration_id: string;
  user_id: string;
  status: BulkImportStatus;
  created_dttm: string;
  updated_at: string;
  total_rows: number;
  rows_processed: number;
  rows_valid: number;
  rows_created: number;
  rows_invalid: number;
}

export interface BulkImportStatusResponse {
  code: number;
  message: string;
  data: BulkImportStatusData;
}

export interface BulkImportInvalidRecord {
  import_id: string;
  error_code: string;
  row_number: number;
  error_type: string;
  message: string;
  created_at: string;
  raw_row: string;
}

export interface BulkImportInvalidResponse {
  errors: BulkImportInvalidRecord[];
}

export enum ToggleButtonOption {
  TemplateDownload = 'TEMPLATE-DOWNLOAD',
  CsvUpload = 'CSV-UPLOAD'
}

export enum UploadStatusOptions {
  None = 'NONE',
  Uploading = 'UPLOADING',
  Processing = 'PROCESSING',
  Loaded = 'LOADED'
}
